// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_eAj","cls2":"PodcastPlayer-cls2_99i PodcastPlayer-cls1_eAj"};